<template>
  <v-container class="py-0 px-0">
    <v-card tile>
      <v-card-text class="py-0">
        <v-row justify="center">
          <v-card-text>
            <v-container class="px-0">
              <v-row>
                <v-col cols="12" sm="12" md="6" class="my-0">
                  <v-row>
                    <v-col cols="12" sm="6" md="3" class="fit-content">
                      <v-text-field
                        label="KC"
                        hide-details
                        class="pa-0 ma-0"
                        disabled
                        :loading="loading.kc"
                        v-model="formData.kc"
                        ref="kc"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="fit-content">
                      <v-text-field
                        label="KV"
                        hide-details
                        class="pa-0 ma-0"
                        :loading="loading.kv"
                        @blur="updateKV"
                        @keydown.enter="focusTglStuffing"
                        v-model="formData.kv"
                        ref="kv"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="fit-content">
                      <label for="tgl_stuffing">Tgl Stuffing</label>
                      <input
                        type="date"
                        id="tgl_stuffing"
                        class="w-100"
                        placeholder="Tanggal TTB"
                        v-model="formData.tgl_stuffing"
                        @keydown.enter="focusCargo"
                        ref="tgl_stuffing"
                        autofocus
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="fit-content">
                      <v-text-field
                        label="Cargo"
                        hide-details
                        class="pa-0 ma-0"
                        @blur="updateCargo"
                        v-model="formData.cargo"
                        @keydown.enter="focusPetugasStuffing"
                        ref="cargo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-text-field
                        label="Petugas Stuffing"
                        hide-details
                        class="pa-0 ma-0"
                        @blur="updatePetugasStuffing"
                        @keydown.enter="focusNoContainer"
                        v-model="formData.petugas_stuffing"
                        :disabled="loading.petugas_stuffing"
                        :loading="loading.petugas_stuffing"
                        ref="petugasStuffing"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-text-field
                        label="No Container"
                        hide-details
                        class="pa-0 ma-0"
                        @blur="updateNoContainer"
                        v-model="formData.no_container"
                        @keydown.enter="focusNoSeal"
                        ref="noContainer"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-text-field
                        label="No Seal"
                        hide-details
                        class="pa-0 ma-0"
                        @blur="updateNoSeal"
                        v-model="formData.no_seal"
                        @keydown.enter="focusJenisContainer"
                        ref="noSeal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-autocomplete
                        label="Jenis Cont"
                        :items="items.jenis_container"
                        dense
                        v-model="formData.jenis_container"
                        hide-details
                        @keydown.enter="focusNamaPelayaran"
                        ref="jenisContainer"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <!-- <v-text-field label="asfd" ref="kondisiStuffing" @keydown.enter="focusPrioritasBerangkat"></v-text-field> -->
                      <v-combobox
                        label="Nama Pelayaran"
                        :items="items.pelayaran"
                        :loading="loading.pelayaran"
                        :disabled="loading.pelayaran"
                        v-model="formData.pelayaran"
                        dense
                        hide-details
                        @keydown.enter="focusKondisiStuffing"
                        ref="pelayaran"
                      >
                        <template #no-data>
                          <small class="ml-2"
                            ><a
                              href=""
                              @click.prevent="state.createPelayaran = true"
                              >Add New</a
                            ></small
                          >
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-autocomplete
                        label="Kondisi Stuffing"
                        :items="items.kondisi_stuffing"
                        dense
                        v-model="formData.kondisi_stuffing"
                        hide-details
                        @keydown.enter="focusPrioritasBerangkat"
                        ref="kondisiStuffing"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-autocomplete
                        :items="items.prioritas_berangkat"
                        label="Prioritas Berangkat"
                        dense
                        v-model="formData.prioritas_berangkat"
                        hide-details
                        @keydown.enter="focusKeteranganJasa"
                        ref="prioritasBerangkat"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-combobox
                        label="Keterangan Jasa di Tujuan"
                        :items="items.keterangan_di_tujuan"
                        :loading="loading.keterangan_di_tujuan"
                        :disabled="loading.keterangan_di_tujuan"
                        v-model="formData.keterangan_di_tujuan"
                        dense
                        hide-details
                        @keydown.enter="focusUkuranContainer"
                        ref="keteranganJasa"
                      >
                        <template #no-data>
                          <small class="ml-2"
                            ><a
                              href=""
                              @click.prevent="
                                state.createKeteranganTujuan = true
                              "
                              >Add New</a
                            ></small
                          >
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-autocomplete
                        :items="items.ukuran_container"
                        label="Ukuran Cont"
                        dense
                        v-model="formData.ukuran_container"
                        hide-details
                        @keydown.enter="focusPortTujuan"
                        ref="ukuranContainer"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-combobox
                        :items="items.port_tujuan"
                        v-model="formData.port_tujuan"
                        :loading="loading.port_tujuan"
                        :disabled="loading.port_tujuan"
                        label="Port Tujuan"
                        dense
                        hide-details
                        @keydown.enter="focusKeteranganPembongkaran"
                        ref="portTujuan"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" class="fit-content">
                      <v-text-field
                        label="Keterangan untuk Pembongkaran"
                        hide-details
                        class="pa-0 ma-0"
                        @blur="updateKeteranganPembongkaran"
                        v-model="formData.keterangan_pembongkaran"
                        @keydown.enter="focusFull"
                        ref="keteranganPembongkaran"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-checkbox
                        v-model="formData.full"
                        label="FULL?"
                        @change="updateFull"
                        hide-details
                        ref="full"
                        tabindex="-1"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="fit-content">
                      <v-checkbox
                        v-model="formData.pisah_container"
                        label="Pisah Container"
                        @change="updatePisahContainer"
                        hide-details
                        tabindex="-1"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-simple-table height="300px" fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left" style="min-width: 120px">KS</th>
                          <th class="text-left" width="50%">TTB</th>
                          <th class="text-center no-wrap">Koli In</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <v-text-field
                              dense
                              hide-details
                              class="pa-0 ma-0"
                              ref="focusKS"
                              disabled
                            ></v-text-field>
                          </td>
                          <td>
                            <v-combobox
                              v-model="formDetilData.kodettb"
                              label="TTB"
                              :items="items.ttb"
                              :loading="loading.ttb"
                              :disabled="loading.ttb"
                              dense
                              hide-details
                              ref="focusTTB"
                              @keydown.enter="focusKoliIn"
                              @change="focusKoliIn"
                            >
                            </v-combobox>
                          </td>
                          <td>
                            <v-text-field
                              v-model="formDetilData.koli_in"
                              dense
                              hide-details
                              class="pa-0 ma-0"
                              ref="focusKoliIn"
                              @keydown.enter="addContainerDetil"
                            ></v-text-field>
                          </td>
                          <!-- <td>
                            <button type="button">Add</button>
                          </td> -->
                        </tr>
                        <FormDetil
                          v-for="container in data.containerDetils"
                          :key="container.id"
                          :data="container"
                          @update-detil="fetchContainerDetils"
                          @fetch-ttb="fetchTTB"
                        />
                      </tbody>
                    </template>
                  </v-simple-table>
                  <h5>Total Koli In: {{ totalKoliIn }}</h5>
                  <h5>Total M3: {{ totalM3 }}</h5>
                  <h5>Total Ton: {{ totalTon }}</h5>
                </v-col>
              </v-row>
            </v-container>
            <!-- <small>*indicates required field</small> -->
          </v-card-text>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Pelayaran Modal -->
    <CreatePelayaran
      :openModal="state.createPelayaran"
      :tempData="formData.pelayaran"
      @update-data="changePelayaran"
      @close-modal="
        state.createPelayaran = false;
        formData.pelayaran = '';
      "
    />

    <!-- Modal keterangan di Tujuan -->
    <CreateKeteranganTujuan
      :openModal="state.createKeteranganTujuan"
      :tempData="formData.keterangan_di_tujuan"
      @update-data="changeKeteranganTujuan"
      @close-modal="
        state.createKeteranganTujuan = false;
        formData.keterangan_di_tujuan = '';
      "
    />

    <!-- FindKC Modal -->
    <FindKC :openModal="!haveKC" @close-modal="fetchDataContainer" />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="saveContainer"
    >
      New
      <!-- <v-icon dark>
        mdi-file
      </v-icon> -->
    </v-btn>
  </v-container>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

function localDateYYYYMMDD() {
  const d = new Date();
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0")
  ].join("-");
}

export default {
  name: "ContainerModal",
  props: ["openModal"],
  components: {
    FindKC: () => import("@/components/Container/ContainerModal.vue"),
    FormDetil: () => import("@/components/ContainerDetil/FormDetil.vue"),
    CreatePelayaran: () => import("@/components/Pelayaran/CreateModal.vue"),
    CreateKeteranganTujuan: () =>
      import("@/components/KeteranganJasaDiTujuan/CreateModal.vue")
  },
  data() {
    return {
      dataContainer: {},
      haveKC: false,
      formData: {
        kc: "",
        kv: "",
        tgl_stuffing: localDateYYYYMMDD(),
        cargo: "",
        no_container: "",
        petugas_stuffing: "",
        no_seal: "",
        jenis_container: "",
        kondisi_stuffing: "",
        pelayaran: "",
        prioritas_berangkat: "",
        keterangan_di_tujuan: "",
        ukuran_container: "",
        keterangan_pembongkaran: "",
        port_tujuan: "",
        full: false,
        pisah_container: false
      },
      formDetilData: {
        kodettb: "",
        koli_in: ""
      },
      loading: {
        pelayaran: false,
        petugas_stuffing: false,
        keterangan_di_tujuan: false,
        port_tujuan: false,
        kc: false,
        kv: false,
        ttb: false,
        add_container_detil: false
      },
      items: {
        jenis_container: [
          {
            text: "1. A-FCL-FO",
            value: "A-FCL-FO"
          },
          {
            text: "2. B-FCL",
            value: "B-FCL"
          },
          {
            text: "3. C-LCL",
            value: "C-LCL"
          },
          {
            text: "4. D-LC",
            value: "D-LC"
          }
        ],
        kondisi_stuffing: [
          {
            text: "1. Stuffing Pelabuhan",
            value: "Stuffing Pelabuhan"
          },
          {
            text: "2. Stuffing Gudang",
            value: "Stuffing Gudang"
          },
          {
            text: "3. Stuffing Pengirim",
            value: "Stuffing Pengirim"
          }
        ],
        prioritas_berangkat: [
          {
            text: "1. Penting",
            value: "1. Penting"
          },
          {
            text: "2. Biasa",
            value: "2. Biasa"
          },
          {
            text: "3. Tidak Penting",
            value: "3. Tidak Penting"
          }
        ],
        ukuran_container: [
          {
            text: "1. 20 Feet",
            value: "20 Feet"
          },
          {
            text: "2. 40 Feet",
            value: "40 Feet"
          },
          {
            text: "3. 40 HC",
            value: "40 HC"
          }
        ],
        pelayaran: [],
        petugas_stuffing: [],
        keterangan_di_tujuan: [],
        port_tujuan: [],
        ttb: []
      },
      state: {
        createPelayaran: false,
        createKeteranganTujuan: false
      },
      data: {
        containerDetils: []
      }
    };
  },
  computed: {
    mini: sync("app/mini"),
    totalKoliIn() {
      return this.data.containerDetils.reduce(
        (a, b) => a + parseInt(b.koli_in || 0),
        0
      );
    },
    totalM3() {
      // koli masuk dibagi total koli ttb, dikali total m3 ttb
      let totalKoliTTB = 0;
      let totalM3TTB = 0;
      let totalKoliIn = 0;

      this.data.containerDetils.forEach(el => {
        totalKoliIn += parseInt(el.koli_in || 0);
        totalKoliTTB += parseInt(el.ttb.total_koli || 0);

        el.ttb.ttb_rinci.forEach(ttbRinci => {
          totalKoliTTB += parseInt(ttbRinci.koli || 0);
          totalM3TTB += parseFloat(ttbRinci.m3 || 0);
        });
      });

      return ((totalKoliIn / totalKoliTTB) * totalM3TTB).toFixed(2);
    },
    totalTon() {
      // koli masuk dibagi total koli ttb, dikali total ton ttb
      let totalKoliTTB = 0;
      let totalTonTTB = 0;
      let totalKoliIn = 0;

      this.data.containerDetils.forEach(el => {
        totalKoliIn += parseInt(el.koli_in || 0);
        totalKoliTTB += parseInt(el.ttb.total_koli || 0);

        el.ttb.ttb_rinci.forEach(ttbRinci => {
          totalKoliTTB += parseInt(ttbRinci.koli || 0);
          totalTonTTB += parseFloat(ttbRinci.ton || 0);
        });
      });

      return ((totalKoliIn / totalKoliTTB) * totalTonTTB).toFixed(2);
    }
  },
  watch: {
    openModal(val) {
      this.fetchPortTujuan();
      this.fetchPelayaran();
      // this.fetchPetugasStuffing();
      this.fetchKeteranganTujuan();
      this.fetchTTB();

      if (val) {
        this.fetchKC();
      }
    },
    "formData.no_container"(val) {
      if (val) {
        // if (val.length == 4) {
        //   this.formData.no_container = val.toUpperCase() + '-';
        // }

        // if (val.length == 11) {
        //   this.formData.no_container = val.toUpperCase() + '-';
        // }

        if (val.length == 4) {
          this.formData.no_container = this.replaceAt(val, 4, " ");
        }

        if (val.length == 11) {
          this.formData.no_container = this.replaceAt(val, 11, "-");
        }

        this.formData.no_container = this.formData.no_container.toUpperCase();
      }
    },
    "formData.tgl_stuffing"(val) {
      if (val) {
        this.updateTglStuffing();
      }
    },
    // "formData.petugas_stuffing"(val) {
    //   if (val) {
    //     this.updatePetugasStuffing();
    //   }
    // },
    "formData.jenis_container"(val) {
      if (val) {
        this.updateJenisCont();
      }
    },
    "formData.kondisi_stuffing"(val) {
      if (val) {
        this.updateKondisiStuffing();
      }
    },
    "formData.pelayaran"(val) {
      if (val) {
        this.updateNamaPelayaran();
      }
    },
    "formData.prioritas_berangkat"(val) {
      if (val) {
        this.updatePrioritasBerangkat();
      }
    },
    "formData.keterangan_di_tujuan"(val) {
      if (val) {
        this.updateKeteranganJasaDiTujuan();
      }
    },
    "formData.ukuran_container"(val) {
      if (val) {
        this.updateUkuranCont();
      }
    },
    "formData.port_tujuan"(val) {
      if (val) {
        this.updatePortTujuan();
      }
    },
    dataContainer(val) {
      this.formData.kc = val.kc;

      this.$nextTick(() => {
        this.$refs.tgl_stuffing.focus();
      });

      if (val.kv) {
        this.formData.kv = val.kv;
      }

      if (val.tgl_stuffing) {
        this.formData.tgl_stuffing = val.tgl_stuffing;
      } else {
        this.formData.tgl_stuffing = localDateYYYYMMDD();
      }

      if (val.cargo) {
        this.formData.cargo = val.cargo;
      }

      if (val.no_container) {
        this.formData.no_container = val.no_container;
      }

      if (val.petugas_stuffing) {
        this.formData.petugas_stuffing = val.petugas_stuffing;
      }

      if (val.no_seal) {
        this.formData.no_seal = val.no_seal;
      }

      if (val.jenis_container) {
        this.formData.jenis_container = val.jenis_container;
      }

      if (val.kondisi_stuffing) {
        this.formData.kondisi_stuffing = val.kondisi_stuffing;
      }

      if (val.pelayaran) {
        this.formData.pelayaran = {
          text:
            val.pelayaran_detil.nama + ` - ${val.pelayaran_detil.keterangan}`,
          value: val.pelayaran_detil.id
        };
      }

      if (val.prioritas_berangkat) {
        this.formData.prioritas_berangkat = val.prioritas_berangkat;
      }

      if (val.keterangan_di_tujuan) {
        this.formData.keterangan_di_tujuan = {
          text:
            val.keterangan_tujuan_detil.tos +
            ` - ${val.keterangan_tujuan_detil.ket}`,
          value: val.keterangan_tujuan_detil.id
        };
      }

      if (val.ukuran_container) {
        this.formData.ukuran_container = val.ukuran_container;
      }

      if (val.keterangan_pembongkaran) {
        this.formData.keterangan_pembongkaran = val.keterangan_pembongkaran;
      }

      if (val.port_tujuan) {
        this.formData.port_tujuan = val.port_tujuan;
      }

      if (val.full) {
        if (val.full == "Y") {
          this.formData.full = true;
        } else {
          this.formData.full = false;
        }
      }

      if (val.pisah_container) {
        this.formData.pisah_container = val.pisah_container === "Y";
      }

      if (val.container_detil) {
        this.data.containerDetils = val.container_detil;
      }
    },
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    canPersistContainer() {
      const hasExistingContainer = !!(
        this.dataContainer && this.dataContainer.id
      );
      const hasNoContainer = !!(
        this.formData.no_container && this.formData.no_container.trim()
      );

      return hasExistingContainer || hasNoContainer;
    },

    saveContainer() {
      this.formData = {
        kc: "",
        tgl_stuffing: localDateYYYYMMDD(),
        cargo: "",
        no_container: "",
        petugas_stuffing: "",
        no_seal: "",
        jenis_container: "",
        kondisi_stuffing: "",
        pelayaran: "",
        prioritas_berangkat: "",
        keterangan_di_tujuan: "",
        ukuran_container: "",
        keterangan_pembongkaran: "",
        port_tujuan: "",
        full: false,
        pisah_container: false
      };

      this.data = {
        containerDetils: []
      };

      this.haveKC = false;
    },
    fetchDataContainer(val) {
      this.haveKC = true;
      this.mini = true;

      this.dataContainer = val;
    },
    async fetchContainerDetils() {
      await axios
        .get(`container-detil?kc=${this.formData.kc}`)
        .then(res => {
          this.data.containerDetils = res.data;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKC() {
      this.loading.kc = true;

      await axios
        .get(`kc`)
        .then(res => {
          this.loading.kc = false;

          this.formData.kc = res.data.kc;
        })
        .catch(err => {
          this.loading.kc = false;

          alert(err.response.data.message);
        });
    },
    async fetchPortTujuan() {
      this.loading.port_tujuan = true;

      await axios
        .get(`port-tujuan`)
        .then(res => {
          this.items.port_tujuan = res.data;

          this.loading.port_tujuan = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchPelayaran() {
      this.loading.pelayaran = true;

      await axios
        .get(`pelayaran`)
        .then(res => {
          this.items.pelayaran = res.data.map(item => ({
            text: item.nama + ` - ${item.keterangan}`,
            value: item.id
          }));

          this.loading.pelayaran = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKeteranganTujuan() {
      this.loading.keterangan_di_tujuan = true;

      await axios
        .get(`keterangan-jasa-di-tujuan`)
        .then(res => {
          this.items.keterangan_di_tujuan = res.data.map(item => ({
            text: item.tos + ` - ${item.ket}`,
            value: item.id
          }));

          this.loading.keterangan_di_tujuan = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchPetugasStuffing() {
      this.loading.petugas_stuffing = true;

      await axios
        .get(`lapangan`)
        .then(res => {
          this.items.petugas_stuffing = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.petugas_stuffing = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchTTB() {
      this.loading.ttb = true;

      await axios
        .get(`ttb`)
        .then(res => {
          this.items.ttb = res.data.map(item => ({
            text: `${item.kodettb} - ${item.nottb} dari: ${
              item.pengirim_detil ? item.pengirim_detil.nama : ""
            }; utk: ${
              item.penerima_detil ? item.penerima_detil.nama : ""
            }; TKoli: ${item.total_koli}; sisa: ${item.sisa}`,
            value: item.kodettb
          }));

          this.loading.ttb = false;
        })
        .catch(err => {
          this.loading.ttb = false;

          alert(err.response.data.message);
        });
    },
    async fetchTTBAfterAdd() {
      this.loading.ttb = true;

      await axios
        .get(`ttb`)
        .then(res => {
          this.items.ttb = res.data.map(item => ({
            text: `${item.kodettb} - ${item.nottb} dari: ${
              item.pengirim_detil ? item.pengirim_detil.nama : ""
            }; utk: ${
              item.penerima_detil ? item.penerima_detil.nama : ""
            }; TKoli: ${item.total_koli}; sisa: ${item.sisa}`,
            value: item.kodettb
          }));

          this.loading.ttb = false;

          this.focusTTB();
        })
        .catch(err => {
          this.loading.ttb = false;

          alert(err.response.data.message);
        });
    },
    async changePelayaran(item) {
      this.loading.pelayaran = true;
      this.state.createPelayaran = false;

      await this.fetchPelayaran();

      this.formData.pelayaran = {
        text: item.nama + ` - ${item.keterangan}`,
        value: item.id
      };

      this.focusKondisiStuffing();
      this.loading.pelayaran = false;
    },
    async changeKeteranganTujuan(item) {
      this.loading.keterangan_di_tujuan = true;
      this.state.createKeteranganTujuan = false;

      await this.fetchKeteranganTujuan();

      this.formData.keterangan_di_tujuan = {
        text: item.tos + ` - ${item.ket}`,
        value: item.id
      };

      this.focusUkuranContainer();
      this.loading.keterangan_di_tujuan = false;
    },
    async updateKV() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/kv`, {
          kc: this.formData.kc,
          kv: this.formData.kv
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate KV");
        });
    },
    async updateTglStuffing() {
      if (!this.formData.kc) return;
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/tgl_stuffing`, {
          kc: this.formData.kc,
          tgl_stuffing: this.formData.tgl_stuffing
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Tanggal Stuffing");
        });
    },
    async updateCargo() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/cargo`, {
          kc: this.formData.kc,
          cargo: this.formData.cargo
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Cargo");
        });
    },
    async updatePetugasStuffing() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/petugas_stuffing`, {
          kc: this.formData.kc,
          petugas_stuffing: this.formData.petugas_stuffing
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Petugas Stuffing");
        });
    },
    async updateNoContainer() {
      await axios
        .put(`update-container/no-container`, {
          kc: this.formData.kc,
          no_container: this.formData.no_container
        })
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async updateNoSeal() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/no-seal`, {
          kc: this.formData.kc,
          no_seal: this.formData.no_seal
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Nomor Seal");
        });
    },
    async updateJenisCont() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/jenis-container`, {
          kc: this.formData.kc,
          jenis_container: this.formData.jenis_container
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Jenis Cont");
        });
    },
    async updateKondisiStuffing() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/kondisi-stuffing`, {
          kc: this.formData.kc,
          kondisi_stuffing: this.formData.kondisi_stuffing
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Kondisi Stuffing");
        });
    },
    async updateNamaPelayaran() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/pelayaran`, {
          kc: this.formData.kc,
          pelayaran: this.formData.pelayaran.value
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Nama Pelayaran");
        });
    },
    async updatePrioritasBerangkat() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/prioritas-berangkat`, {
          kc: this.formData.kc,
          prioritas_berangkat: this.formData.prioritas_berangkat
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Prioritas Berangkat");
        });
    },
    async updateKeteranganJasaDiTujuan() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/keterangan-di-tujuan`, {
          kc: this.formData.kc,
          keterangan_di_tujuan: this.formData.keterangan_di_tujuan.value
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Keterangan di Tujuan");
        });
    },
    async updateUkuranCont() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/ukuran-container`, {
          kc: this.formData.kc,
          ukuran_container: this.formData.ukuran_container
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Keterangan Ukuran Cont");
        });
    },
    async updateKeteranganPembongkaran() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/keterangan-pembongkaran`, {
          kc: this.formData.kc,
          keterangan_pembongkaran: this.formData.keterangan_pembongkaran
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Keterangan Pembongkaran");
        });
    },
    async updatePortTujuan() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/port-tujuan`, {
          kc: this.formData.kc,
          port_tujuan: this.formData.port_tujuan
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Port Tujuan");
        });
    },
    async updateFull() {
      this.focusTTB();

      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/full`, {
          kc: this.formData.kc,
          full: this.formData.full
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Full");
        });
    },
    async updatePisahContainer() {
      if (!this.canPersistContainer()) return;

      await axios
        .put(`update-container/pisah-container`, {
          kc: this.formData.kc,
          pisah_container: this.formData.pisah_container
        })
        .then(res => {})
        .catch(err => {
          alert("Gagal Mengupdate Pisah Container");
        });
    },
    async addContainerDetil() {
      if (this.loading.add_container_detil) return;

      this.loading.add_container_detil = true;

      await axios
        .post(`container-detil?kc=${this.formData.kc}`, this.formDetilData)
        .then(res => {
          this.formDetilData = {
            kodettb: "",
            koli_in: ""
          };

          this.fetchContainerDetils();
          this.fetchTTBAfterAdd();
          // this.fetchTTB();
          this.focusTTB();

          this.loading.add_container_detil = false;
        })
        .catch(err => {
          this.loading.add_container_detil = false;

          alert(err.response.data.message);
        });
    },
    focusTglStuffing() {
      this.$refs.tgl_stuffing.focus();
    },
    focusCargo() {
      if (this.formData.tgl_stuffing) {
        this.$refs.cargo.$refs.input.click();
      }
    },
    focusPetugasStuffing() {
      if (this.formData.cargo) {
        this.$refs.petugasStuffing.$refs.input.click();
      }
    },
    focusNoContainer() {
      if (this.formData.petugas_stuffing) {
        this.$refs.noContainer.$refs.input.click();
      }
    },
    focusNoSeal() {
      if (this.formData.no_container) {
        this.$refs.noSeal.$refs.input.click();
      }
    },
    focusJenisContainer() {
      // if (this.formData.no_seal) {
      setTimeout(() => {
        this.$refs.jenisContainer.$refs.input.click();
      }, 1);
      // }
    },
    focusKondisiStuffing() {
      // if (this.formData.jenis_container) {
      setTimeout(() => {
        if (
          this.formData.pelayaran != "" &&
          typeof this.formData.pelayaran !== "object"
        ) {
          if (
            !this.items.pelayaran.some(arr =>
              arr.text.match(new RegExp(this.formData.pelayaran, "i"))
            )
          ) {
            this.state.createPelayaran = true;
          }
        } else {
          if (this.formData.pelayaran) {
            this.$refs.kondisiStuffing.$refs.input.click();
          }
        }
      }, 1);
      // }
    },
    focusNamaPelayaran() {
      // if (this.formData.kondisi_stuffing) {
      setTimeout(() => {
        this.$refs.pelayaran.$refs.input.click();
      }, 1);
      // }
    },
    focusPrioritasBerangkat() {
      // if (this.formData.pelayaran) {
      setTimeout(() => {
        this.$refs.prioritasBerangkat.$refs.input.click();
      }, 1);
      // }
    },
    focusKeteranganJasa() {
      // if (this.formData.prioritas_berangkat) {
      setTimeout(() => {
        this.$refs.keteranganJasa.$refs.input.click();
      }, 1);
      // }
    },
    focusUkuranContainer() {
      // if (this.formData.keterangan_di_tujuan) {
      setTimeout(() => {
        if (
          this.formData.keterangan_di_tujuan != "" &&
          typeof this.formData.keterangan_di_tujuan !== "object"
        ) {
          if (
            !this.items.keterangan_di_tujuan.some(arr =>
              arr.text.match(
                new RegExp(this.formData.keterangan_di_tujuan, "i")
              )
            )
          ) {
            this.state.createKeteranganTujuan = true;
          }
        } else {
          if (this.formData.keterangan_di_tujuan) {
            this.$refs.ukuranContainer.$refs.input.click();
          }
        }
      }, 1);
      // }
    },
    focusPortTujuan() {
      // if (this.formData.ukuran_container) {
      setTimeout(() => {
        this.$refs.portTujuan.$refs.input.click();
      }, 1);
      // }
    },
    focusKeteranganPembongkaran() {
      // if (this.formData.port_tujuan) {
      setTimeout(() => {
        this.$refs.keteranganPembongkaran.$refs.input.click();
      }, 1);
      // }
    },
    focusFull() {
      // if (this.formData.keterangan_pembongkaran) {
      setTimeout(() => {
        this.$refs.full.$refs.input.focus();
      }, 1);
      // }
    },
    focusKS() {
      this.$refs.focusKS.$refs.input.focus();
    },
    focusTTB() {
      this.$nextTick(() => {
        this.$refs.focusTTB.$refs.input.click();
      });
    },
    focusKoliIn() {
      this.$refs.focusKoliIn.$refs.input.click();
    },
    replaceAt(str, index, replacement) {
      return (
        str.substring(0, index) +
        replacement +
        str.substring(index + replacement.length)
      );
    }
  },
  created() {
    this.fetchPortTujuan();
    this.fetchPelayaran();
    // this.fetchPetugasStuffing();
    this.fetchKeteranganTujuan();
    this.fetchTTB();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}

table thead th {
  font-size: 12px !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}
</style>
